import { useMainStore } from '@/store'
import type { RouteLocationRaw } from '@/types'
import { FLOATING_BUTTON_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'
import useABTestV2 from '@/utils/abtest/useABTestV2'
import GTM from '@/utils/tracking/gtm'

enum Status {
  DISABLED,
  A_PATTERN,
  B_PATTERN
}

export enum FilterButton {
  PURPOSE = '上部_目的',
  PREFECTURE = '上部_都道府県',
  AREA = '上部_エリア',
  DETAIL_CONDITION = '上部_詳細条件',
  DATETIME = '上部_日付',
  DATETIME_SHORTCUT = 'カレンダー',
  FLOATING_BUTTON = 'フロート',
  TOP_BUTTONS = '上部'
}

export const useABTestIssue395 = (customRoute?: RouteLocationRaw) => {
  if (import.meta.server) {
    return {
      sendOnComponentViewed: () => {},
      sendOnLinkToDetailPageClicked: () => {},
      sendOnFloatingButtonClicked: () => {},
      sendOnFilterButtonClicked: () => {},
      shouldSendGAEvent: ref(false)
    }
  }

  const store = useMainStore()
  const route = useRoute()

  const { isAPattern, isBPattern } = useABTestV2(FLOATING_BUTTON_AB_TEST_CONFIG)

  const status = computed(() => {
    if (isAPattern) return Status.A_PATTERN
    if (isBPattern) return Status.B_PATTERN
    return Status.DISABLED
  })
  const pageDetector = computed(() => (customRoute ? new PageDetector(customRoute) : new PageDetector(route)))
  const shouldSendGAEvent = computed(() => status.value !== Status.DISABLED && Boolean(store.isSP) && pageDetector.value.isSearchComponentsPage)

  const sendOnComponentViewed = () => {
    if (status.value === Status.DISABLED) return
    GTM.sendEventToGa({
      category: 'issue395',
      action: 'view',
      label: status.value === Status.A_PATTERN ? 'A群' : 'B群'
    })
  }

  const sendOnLinkToDetailPageClicked = () => {
    if (status.value === Status.DISABLED) return
    GTM.sendEventToGa({
      category: 'issue395',
      action: 'click',
      label: status.value === Status.A_PATTERN ? 'A群' : 'B群'
    })
  }

  const sendOnFloatingButtonClicked = () => {
    if (status.value === Status.DISABLED) return

    GTM.sendEventToGa({
      category: 'issue395_フロートボタン',
      action: 'click',
      label: status.value === Status.A_PATTERN ? 'A群' : 'B群'
    })
  }

  const sendOnFilterButtonClicked = (button: FilterButton) => {
    if (status.value === Status.DISABLED) return
    GTM.sendEventToGa({
      category: 'issue395_検索',
      action: 'click',
      label: status.value === Status.A_PATTERN ? `A群_${button}` : `B群_${button}`
    })
  }

  return {
    sendOnComponentViewed,
    sendOnLinkToDetailPageClicked,
    sendOnFloatingButtonClicked,
    sendOnFilterButtonClicked,
    shouldSendGAEvent
  }
}
